<div id="button">
  <button type="{{type}}" disabled="{{disabled}}" class="{{class}}" (click)="onClickButton($event)">
    {{ label }}
  </button>
</div>
